export default __webpack_public_path__ + "static/media/logo.c3277976.svg";